<template>
    <div class="bg-gray-200 shadow-xl w-full h-[30rem] rounded-xl relative overflow-hidden animate-pulse">
        <div
            class="absolute bottom-0 left-0 right-0 p-3 min-h-[15rem] bg-gradient-to-t from-gray-300 via-gray-300 to-transparent rounded-b-xl">
            <div class="mt-20">
                <div class="flex flex-row justify-between items-center">
                    <div class="bg-gray-400 h-4 w-16 rounded-full"></div>
                    <div class="bg-gray-400 h-4 w-24 rounded-full"></div>
                </div>
                <div class="mt-4 space-y-2">
                    <div class="bg-gray-400 h-6 w-3/4 rounded"></div>
                </div>
            </div>
        </div>
    </div>
</template>
